{
    "MakeCallTitle": "Faire un appel",
    "MakeCallTooltip": "Effectuez un appel vers le dispositif correspondant.",
    "IttTitle": "Transfert d'enquête",
    "IttTooltip": "Effectuez un appel de consultation de demande au dispositif correspondant afin de commencer une opération de transfert d'appel.",
    "CallDetailsTitle": "Appelez les détails...",
    "CallDetailsTooltip": "Affichez des informations détaillées sur l'appel dans une nouvelle fenêtre.",
    "CompleteTransferTitle": "Transfert complet",
    "CompleteTransferTooltip": "Terminez l'opération de transfert de l'appel en attente commencée précédemment en déplaçant l'appel en attente vers la destination cible précédemment appelée.",
    "PickupThisCallTitle": "Décrocher cet appel",
    "PickupThisCallTooltip": "Répondez immédiatement à cet appel d'alerte sur votre propre poste.",
    "StealThisCallTitle": "Voler cet appel",
    "StealThisCallTooltip": "Déplacez l'appel en cours de réponse ou d'alerte vers votre poste où il sonnera ultérieurement.",
    "SendToCallTitle": "Envoyer un appel à...",
    "SendToCallTooltip": "Déplacer l'appel en cours de réponse ou d'alerte vers une nouvelle destination spécifique où il sonnera par la suite.",
    "MonitorTitle": "Moniteur",
    "MonitorTooltip": "Options de surveillance des appareils et des appels.",
    "SilentMonitorTitle": "Moniteur silencieux",
    "SilentMonitorTooltip": "Lancez une session de surveillance silencieuse avec l'appel actuellement répondu sur l'appareil.",
    "ForcedIntrudeTitle": "Intrusion forcée",
    "ForcedIntrudeTooltip": "S'immiscer dans l'appel en cours sur l'appareil correspondant, afin de pouvoir y participer activement.",
    "RecordCallTitle": "Enregistrer un appel",
    "RecordCallTooltip": "Effectuer une opération d'enregistrement d'appel en direct sur l'appel actuellement répondu sur l'appareil.",
    "RegisterCallbackTitle": "Enregistrer le rappel",
    "RegisterCallbackTooltip": "Afficher un message sur l'appareil correspondant, lui rappelant de rappeler votre poste particulier.",
    "AgentSignInOutTitle": "Entrée\/sortie de l'agent",
    "AgentSignInOutTooltip": "Signature d'entrée\/sortie de l'extension.",
    "SignInTitle": "Se connecter...",
    "SignInTitleAllGroups": "Se connecter (tous les groupes)",
    "SignInTooltip": "Inscrivez le dispositif ou l'agent correspondant, ce qui le rend \"de service\" et potentiellement disponible pour répondre aux appels ACD.",
    "SignOutTitle": "Se déconnecter",
    "SignOutTitleAllGroups": "Déconnexion (tous les groupes)",
    "SignOutTooltip": "Signalez le dispositif ou l'agent correspondant comme étant hors service et non disponible pour répondre aux appels ACD.",
    "GroupsTitle": "Groupes",
    "GroupsTooltip": "Choisissez les groupes ACD dans lesquels cet agent est inscrit.",
    "NoGroupsTooltip": "Aucun groupe ACD n'a été trouvé pour cet agent.",
    "GroupsAllTitle": "[All]",
    "SetDndOnTitle": "Activer le DND",
    "SetDndOnTooltip": "Activez la fonction \"Ne pas déranger\" sur l'appareil, ce qui le rendra indisponible pour recevoir des appels.",
    "SetDndOffTitle": "Régler DND Off",
    "SetDndOffTooltip": "Désactivez la fonction \"Ne pas déranger\" sur l'appareil, ce qui le rendra disponible pour recevoir des appels entrants.",
    "SetStatusTitle": "Définir l'état",
    "SetStatusTooltip": "Définir le statut ACD pour cet agent.",
    "AvailableTitle": "Disponible sur",
    "AvailableTooltip": "Mettez l'agent dans l'état Disponible, ce qui le rendra disponible pour répondre aux appels ACD.",
    "DndTitle": "DND",
    "DndTooltip": "Mettez l'agent en état de DND, ce qui le rendra indisponible pour répondre aux appels ACD.",
    "WrapUpTitle": "Récapitulation",
    "WrapUpTooltip": "Mettez l'agent dans l'état Wrap-Up, ce qui le rendra indisponible pour répondre aux appels ACD.",
    "NotAvailableTitle": "Non disponible",
    "NotAvailableTooltip": "Mettez l'agent en état de non-disponibilité ACD et spécifiez en plus un code de raison, qui peut être utilisé pour identifier pourquoi l'agent correspondant n'est pas spécifiquement disponible pour répondre aux appels ACD.",
    "NoReasonTitle": "[Pas de raison]",
    "NoReasonTooltip": "Mettre l'agent dans l'état ACD non disponible sans raison.",
    "AdvancedTooltip": "Actions avancées de contrôle des appels.",
    "AnswerCallTitle": "Répondre à l'appel",
    "AnswerCallTooltip": "Répondre à l'appel d'alerte en cours.",
    "ClearCallTitle": "Appel clair",
    "ClearCallTooltip": "Terminez l'appel correspondant.",
    "AdminOnlyTitle": "Admin seulement",
    "AdminOnlyTooltip": "Actions réservées aux administrateurs.",
    "DeletePhantomTitle": "Supprimer l'appel fantôme",
    "DeletePhantomTooltip": "Force l'application à cesser de modéliser l'appel correspondant comme actif, ce qui peut nuire aux statistiques d'appel.",
    "RowOptions_AdvancedTitle": "Avancé",
    "NAME": "RowOptions",
    "SetAccountCodeMenuOptionTitle": "Définir le code de compte",
    "SetAccountCodeMenuOptionTooltip": "Définir le code de compte pour cet appel.",
    "NoAccountCodeMenuOptionTitle": "[Pas de code de compte]",
    "NoAccountCodeMenuOptionTooltip": "Annuler le code de compte",
    "AccountCodeMenuOptionTooltip": "Définir le code de compte '{}' pour l'appel."
}